import { FETCH_AMC_SERVICE_DETAILS_API, generateBFFUrl } from '@/configs/apiEndPoints';
import axiosInstance from './axiosConfig';
import generateHttpHeaders from './axiosConfig/generateHttpHeaders';
import { AxiosResponse } from 'axios';
import { GenericError } from '@/errors/GenericServerError';
import { AGREEMENT_ID_QUERY_PARAM, ASSET_ID_QUERY_PARAM } from '@/configs/serviceConstants';

export type MandatoryService = {
  description: string;
  bookingDate: string;
  isAvailed: boolean;
};

export type FetchAmcServiceDetailsResponse = {
  invoiceLink: string | null;
  orderPricePerUnit?: number;
  mandatoryServices: MandatoryService[];
};

export const fetchAmcServiceDetails = (
  assetId: string,
  agreementId: string,
  serverCookie?: any,
): Promise<FetchAmcServiceDetailsResponse> => {
  return axiosInstance
    .get(
      generateBFFUrl(
        `${FETCH_AMC_SERVICE_DETAILS_API}?${ASSET_ID_QUERY_PARAM}=${assetId}&${AGREEMENT_ID_QUERY_PARAM}=${agreementId}`,
      ),
      {
        headers: generateHttpHeaders(serverCookie),
      },
    )
    .then(({ data }) => {
      return data;
    })
    .catch((error: any) => {
      const { response } = error;
      const { data, status, statusText } = response as AxiosResponse;
      throw new GenericError('Something went wrong', status, statusText, data);
    });
};
